<template>
  <v-container id="data-tables" tag="section" fluid>
    <base-material-card color="primary" icon="mdi-file-import-outline" inline class="ml-0 px-5 py-4">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">Importações de Sped</div>
      </template>
      <v-btn
        id="btn-nova-importacao-sped"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float: left"
        relative
        text
        medium
        @click="$router.push({ name: 'Importações Sped Adicionar' })"
      >
        <v-icon left size="30px">mdi-plus-circle</v-icon>
        NOVA IMPORTAÇÃO
      </v-btn>
      <v-text-field
        id="importacao-sped-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 265px"
      />
      <v-divider class="mt-10" />
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        :loading="loading"
        :mobile-breakpoint="800"
        no-data-text="Nenhuma Importação de Spead disponível"
      >
        <template v-slot:[`item.id`]="{ item }">{{ item.id }}</template>
        <template v-slot:[`item.nome`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div class="text-truncate-column" v-bind="attrs" v-on="on">
                {{ item.nome }}
              </div>
            </template>
            <span>{{ item.nome }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.usuario`]="{ item }">
          {{ item.usuario }}
        </template>
        <template v-slot:[`item.data_processamento`]="{ item }">
          {{ item.data_processamento | parseToDateTimeBR }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" :progresso="progresso[item.id]" />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <span id="action-excluir-importacao-sped">
            <tooltip-icon
              :item="{ icon: 'mdi-trash-can-outline', nome: 'Excluir' }"
              :disabled="desabilitarIconExcluir(item.status)"
              @click="openDialogDelete(item.id)"
            />
          </span>
          <span id="action-download-importacao-sped">
            <tooltip-icon
              :item="{ icon: 'mdi-pencil', nome: 'Editar' }"
              :disabled="item.status === 'CRIANDO' ? false : true"
              @click="$router.push(`edit/${item.id}`)"
            />
          </span>
          <span id="action-detalhes-importacao-sped">
            <tooltip-icon
              :item="{ icon: 'mdi-file-find-outline', nome: 'Visualizar Detalhes' }"
              :disabled="dialogDetalhes"
              @click="openDialogDetalhes(item.id)"
            />
          </span>
        </template>
      </v-data-table>
    </base-material-card>
    <dialog-delete
      :showDialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="deletarItem(dialogDeleteData.id)"
    >
      <template slot="title">Deletar Importação de SPED #{{ dialogDeleteData.id }}</template>
      <template slot="body">Tem certeza que deseja deletar essa importação de SPED?</template>
    </dialog-delete>

    <general-dialog-detalhes
      ref="dialogDetalhes"
      persistent
      title="Detalhes da Importação de Sped"
      :showDialog="dialogDetalhes"
      max-width="1200px"
      @changeValue="((dialogDetalhes = $event), (bodyDetalhes = []))"
    >
      <template slot="body">
        <v-data-table
          class="elevation-1 my-3 style-table-dialog-detalhes"
          disable-pagination
          hide-default-footer
          :headers="detalhesHeader"
          :items="bodyDetalhes"
          :mobile-breakpoint="0"
        >
          <template v-slot:[`item.nome`]="{ item }">
            <a href="javascript:void(0)" @click="baixarFile(item)">{{ item.nome }}</a>
          </template>
          <template v-slot:[`item.dataProcessamento`]="{ item }">
            {{ item.dataProcessamento | parseToDateTimeBR }}
          </template>
        </v-data-table>
      </template>
    </general-dialog-detalhes>
  </v-container>
</template>
<script>
  import powerupsActionsMixins from '@/mixins/powerupsActionsMixins.js';
  import pusherMixins from '@/mixins/pusherMixins';
  import importacoesSpedService from '../../services/importacoesSpedService';

  export default {
    components: {
      DialogDelete: () => import('@/components/general/DialogDelete.vue'),
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
      GeneralDialogDetalhes: () => import('@/components/general/GeneralDialogDetalhes.vue'),
      TooltipIcon: () => import('@/components/general/TooltipIcon.vue')
    },

    mixins: [powerupsActionsMixins, pusherMixins],

    props: {
      items: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      powerupService: importacoesSpedService,
      powerupEntityName: 'Importações Sped',
      dialogDetalhes: false,
      progresso: {},
      search: '',
      headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Nome',
          value: 'titulo'
        },
        {
          text: 'Usuário',
          value: 'usuario.nome'
        },
        {
          text: 'Executado',
          value: 'data_processamento'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          sortable: false,
          text: 'Ações',
          value: 'actions',
          class: 'pl-4'
        }
      ],
      bodyDetalhes: [],
      detalhesHeader: [
        {
          text: 'Nome do arquivo',
          value: 'nome'
        },
        {
          text: 'Colisão',
          value: 'colisao',
          align: 'center'
        },
        {
          text: 'Importado',
          value: 'importado',
          align: 'center'
        },
        {
          text: 'Data da Execução',
          value: 'dataProcessamento',
          align: 'center'
        },
        {
          text: 'Observação',
          value: 'observacao',
          align: 'left'
        }
      ]
    }),

    created() {
      this.subscribe();
    },

    methods: {
      subscribe() {
        this.pusherChannel.bind('sped-progress', (data) => {
          this.$set(this.progresso, data.id, data.message);
        });
      },

      openDialogDetalhes(id) {
        importacoesSpedService
          .getFilesImportacao(id)
          .then((resp) => {
            resp.data.data.forEach((file) => {
              this.bodyDetalhes.push({
                id: file.id,
                nome: file.nome,
                colisao: file.atualizar ? 'Atualizar' : 'Ignorar',
                importado: file.importado ? 'Sim' : 'Não',
                dataProcessamento: file.importacoes_sped == null ? '-' : file.importacoes_sped.data_processamento,
                observacao: file.observacao || '-'
              });
            });
          })
          .catch((err) => {
            this.$toast.error('Erro ao buscar resumo de Importações de SPED.', '', { position: 'topRight' });
            console.error(err);
          })
          .finally(() => (this.dialogDetalhes = true));
      },

      baixarFile(item) {
        const id = item.id;
        const nome = item.nome.replace('.txt', '');
        importacoesSpedService
          .baixarFile(id, {
            timeout: 60 * 60 * 1000
          })
          .then(async (response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', response.data.type == 'application/zip' ? nome + '.zip' : nome + '.txt');
            document.body.appendChild(link);
            link.click();

            ((this.dialogDetalhes = false), (this.bodyDetalhes = []));
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error('Erro ao disponibilizar o download.', '', { position: 'topRight' });
          });
      },

      desabilitarIconExcluir(status) {
        if (status == 'SUCESSO' || status == 'EXECUTANDO') {
          return true;
        }
        return false;
      }
    }
  };
</script>
